import React from "react";
import "../resources/css/Song.css";

const Home: React.FC = () => {
  return (
    <div className="home-container">
      <h1 className="home-title">SongRank</h1>
      <p className="home-tagline">
        Rank songs. Battle friends. Climb the leaderboard.
      </p>

      <div className="home-buttons">
        <a href="/games" className="btn-primary">Play Now</a>
        <a href="/leaderboard" className="btn-secondary">Leaderboard</a>
      </div>

      <div className="features">
        <div className="feature-card">
          <h3>🎵 Rank Songs</h3>
          <p>Choose your favourite tracks and see how they stack up.</p>
        </div>

        <div className="feature-card">
          <h3>⚔️ Battle Friends</h3>
          <p>Challenge your mates and climb the SongRank arena.</p>
        </div>

        <div className="feature-card">
          <h3>📊 Track Stats</h3>
          <p>View wins, losses, and your ranking history.</p>
        </div>
      </div>
    </div>
  );
};

export default Home;
